var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Agentes disponibles "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.agentes(["DISP"]).length)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Agentes en pausa "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.agentes([
                      "EPALM",
                      "EPBAÑ",
                      "EPRCON",
                      "EPINTAB",
                      "EPPTINT",
                    ]).length
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Interacciones Pendientes "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.interacciones(["Pendiente"]).length)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Interacciones Activas "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.interacciones(["Contestada"]).length)),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Interacciones Resueltas del Dia "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.interacciones(["Finalizada"]).length)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Interacciones Transferidas "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.interacciones(["Transferida"]).length)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Interacciones No Resueltas del día"),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.interacciones(["FINALIZADA_ERROR"]).length +
                      _vm.interacciones(["Expirada"]).length
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-3 col-md-6 col-12" }, [
        _c("div", { staticClass: "widget style1 white-bg" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-8 text-right text-black-50" }, [
              _c("span", { staticClass: "text-md-title" }, [
                _vm._v(" Interacciones del día "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.interacciones(["Contestada"]).length +
                      _vm.interacciones(["Pendiente"]).length +
                      _vm.interacciones(["Finalizada"]).length +
                      _vm.interacciones(["Transferido"]).length +
                      _vm.interacciones(["Expirada"]).length +
                      _vm.interacciones(["FINALIZADA_ERROR"]).length
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-user-check fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-user-clock fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-comment-exclamation fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-comment-dots fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-check fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-exchange-alt fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-times fa-5x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-4" }, [
      _c("i", { staticClass: "fal fa-flag fa-5x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }